import React, { Component } from 'react';
import './ChannelsButton.scss';
import helpers from '../../../helpers';
import config from '../../../../config';

class ChannelsButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      link: ''
    };
  }

  componentDidMount() {
    window.addEventListener('changeTheme', this.update.bind(this));
    this.update();
  }

  componentWillUnmount() {
    window.removeEventListener('changeTheme', this.update.bind(this));
  }

  trackClick() {
    if (typeof window.tracker === 'undefined') {
      return false;
    }

    return window.tracker.click({
      click_type: 'exit',
      click_name: 'themakanalen',
      chapter_1: 'nederlandfm',
      chapter_2: helpers.getMiniplayer(this).getTheme()
    });
  }

  update() {
    const channel = helpers.getMiniplayer(this).getTheme();

    this.setState({
      active: true,
      link: config[channel].subChannelsUrl
    });
  }

  render() {
    const { active, link } = this.state;

    if (!active) {
      return null;
    }

    if (!link) {
      return false;
    }

    return (
      <a
        className="ChannelsButton clickitem"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Bekijk de themakanalen"
        onClick={this.trackClick.bind(this)}
      >
        <svg viewBox="0 0 16 16">
          <g>
            <rect x="0" y="0" width="7" height="7" />
            <rect x="9" y="0" width="7" height="7" />
            <rect x="0" y="9" width="7" height="7" />
            <rect x="9" y="9" width="7" height="7" />
          </g>
        </svg>
      </a>
    );
  }
}

export default ChannelsButton;
